import React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import MUISwitch from '@mui/material/Switch';
import { formControlLabelStyles, switchStyles, switchIconStyles, switchThumbStyles } from './Switch.style';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
export const Switch = (props) => {
    const { dataQa = 'switch', disabled, field, label = '', labelPlacement = 'start' } = props;
    return (React.createElement(FormControlLabel, { control: React.createElement(MUISwitch, Object.assign({ checked: field === null || field === void 0 ? void 0 : field.value, checkedIcon: React.createElement(Box, { sx: switchThumbStyles },
                React.createElement(Check, { sx: switchIconStyles })), "data-qa": `${dataQa}-core`, disabled: disabled, icon: React.createElement(Box, { sx: switchThumbStyles },
                React.createElement(Close, { sx: switchIconStyles })), sx: switchStyles }, field)), "data-qa": `${dataQa}-formControlLabel`, label: label, labelPlacement: labelPlacement, sx: formControlLabelStyles }));
};
